import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import Input from '@superfunnel/ui-core/v2/Input';
import React from 'react';

interface Props {
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const SearchField = ({ value, onChange }: Props) => {
  return (
    <Input
      icon={<MagnifyingGlassIcon className="h-4 w-4 text-gray-500" />}
      className="h-8 w-full"
      value={value}
      onChange={onChange}
      placeholder="Search"
    />
  );
};
